import { gql } from "lib/apolloClient";

export const bookmarkCourseMutation = gql`
  mutation bookmarkCourse($input: UpdateLearningCourseUserBookmarkInput!) {
    planner {
      bookmarkLearningCourse(input: $input)
    }
  }
`;

export const bookmarkClassMutation = gql`
  mutation bookmarkClass($input: UpdateCourseAsBookmarkInput!) {
    platform {
      updateCourseAsBookmark(input: $input)
    }
  }
`;
